import { get } from "../helpers/api_helper"
// import { get } from "../../helpers/api_helper"

export const fileDownload = ({ url, path, downloadName, extension }) => {
  return get(`${url}`, {
    responseType: "blob",
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response]))
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", `${downloadName}_${Date.now()}.${extension}`)
    document.body.appendChild(link)
    link.click()
  })
}

export const handleDocumentDownload = ({
  path,
  url,
  downloadName,
  extension,
}) => {
  const handleDownload = async () => {
    const response = await fileDownload({
      url: url,
      path,
      downloadName: downloadName,
      extension: extension,
    })
    console.log("response :", response)
  }
  handleDownload()
}
export const getExtension = filePath => {
  const parts = filePath.split(".")
  return parts[1]
}

export const openAndPrintFile = ({ url, extension = "pdf" }) => {
  return get(url, {
    responseType: "blob",
  }).then(response => {
    const blob = new Blob([response], { type: "application/pdf" }) // adjust MIME type if needed
    const blobUrl = window.URL.createObjectURL(blob)

    // Open file in new tab
    const printWindow = window.open(blobUrl, "_blank")

    if (printWindow) {
      printWindow.onload = () => {
        printWindow.focus()
        printWindow.print()
      }
    } else {
      console.warn("Failed to open the print window (maybe blocked by popup blocker).")
    }
  }).catch(error => {
    console.error("Error fetching file:", error)
  })
}